import {
	getDpUrlParam,
	buildDpQueryString,
	scrollIntoView,
	scrollToElementAndAnimate
} from '../../../../includes/assets/js/modules/dpitUtilsInc';
import { Origin, TargetType } from '../../../../public/assets/js/apps/TourStepEditor/store/appMode';

/**
 * 
 * @param {Object} queryParamsDefs Query param definition object for DPIT
 * @param {string} animationClass
 * @param {options} options scrollIntoView options see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
 * @param {string} defaultOriginId 
 * @param {String} originIdKey
 * @param {String} canceledKey
 * @param {string} highlightClass
 */
export const scrollToOriginElementByUrlAndAnimate = async (
	queryParamsDefs,
	animationClass = 'dpit-admin-pulse-anim',
	options = { align: { top: 0.5, left: 0.5 } },
	originIdKey = 'dp_qpb_origin_el_id',
	canceledKey = 'dp_qpb_canceled',
	highlightClass = ''
) => {
	const currentUrl = new URL(window.location);
	let originId = getDpUrlParam(originIdKey, queryParamsDefs, currentUrl);
	if (originId) {
		const element = document.getElementById(originId);
		if (element) {
			const canceled = getDpUrlParam(canceledKey, queryParamsDefs, currentUrl);

			if (canceled === '1') return scrollIntoView(element, options);
			else {
				scrollToElementAndAnimate(element, animationClass, 1000, options, true, '', highlightClass);
				Promise.resolve(true);
			}
		}
		return Promise.resolve(false);
	}
	return Promise.resolve(false);
};


export const getRedirectUrlQueryString = (queryParamsDefs, tourId, builderMode = TargetType.STEP,
	originId = '', originArea = Origin.ADMIN, triggerIdx = null) => {
	// dp_to_check
	const params = {
		dp_qpb_builder_mode: builderMode,
		dp_qpb_builder_origin: originArea,
		dp_qpb_origin_el_id: originId,
		dp_qp_tour_id: tourId,
		dp_qp_run_always_on_load: '1',
		dp_qp_trigger_id: triggerIdx
	};
	return buildDpQueryString(params, queryParamsDefs, '?');
};


export const isUrlVariableProcessingEnabled = () => $('.acf-field[data-name="url_vars_enabled"] .acf-switch').hasClass('-on');

export const getActualVisibleNoticesHeight = () => {
	let res = 0;
	$('.notice:visible').each(function () {
		res += $(this).outerHeight(true);
	});
	return res;
};


export const createOrSetManuallyElement = (text, className = '') => {
	const element = document.createElement('div');
	element.className = className;
	element.innerText = '~ ' + text + ' ~';
	return element;
};

